<template>

  <svg v-if="countryCode == 'ca'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="56" height="44" viewBox="0 0 56 40" enable-background="new 0 0 56 40" xml:space="preserve">
    <polygon fill="#A41C1C" points="0,8 0,24 13.86,16 "/>
    <path fill="#A41C1C" d="M12.97,17.53v12.94L1.77,24L12.97,17.53 M13.86,16L0,24l13.86,8V16L13.86,16z"/>
    <polygon fill="#D81D1D" points="13.86,16 13.86,0 0,8 "/>
    <polygon fill="#E59A2C" points="27.71,8 27.71,24 13.86,16 "/>
    <polygon fill="none" points="13.86,32 13.86,16 27.71,24 "/>
    <path fill="#E59A2C" d="M26.83,25.53v12.94L15.62,32L26.83,25.53 M27.71,24l-13.86,8l13.86,8V24L27.71,24z"/>
    <polygon fill="#FFAD28" points="13.86,16 13.86,0 27.71,8 "/>
    <polygon fill="#30AA9B" points="55.43,8 55.43,24 41.57,16 "/>
    <path fill="#30AA9B" d="M42.45,17.53L53.66,24l-11.21,6.47V17.53 M41.57,16v16l13.86-8L41.57,16L41.57,16z"/>
    <polygon fill="#33C1B3" points="41.57,16 41.57,0 55.43,8 "/>
    <polygon fill="#11557F" points="27.71,8 27.71,24 41.57,16 "/>
    <polygon fill="none" points="41.57,32 41.57,16 27.71,24 "/>
    <path fill="#11557F" d="M28.6,25.53L39.8,32L28.6,38.47V25.53 M27.71,24v16l13.86-8L27.71,24L27.71,24z"/>
    <polygon fill="#0D5F9A" points="41.57,16 41.57,0 27.71,8 "/>
  </svg>

  <svg v-else version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="56" height="44" viewBox="0 0 56 40" enable-background="new 0 0 56 40" xml:space="preserve">
    <polygon fill="#A41C1C" points="0,8 0,24 13.86,16 "/>
	  <path fill="#A41C1C" d="M12.97,17.53v12.94L1.77,24L12.97,17.53 M13.86,16L0,24l13.86,8V16L13.86,16z"/>
    <polygon fill="#D81D1D" points="13.86,16 13.86,0 0,8 "/>
    <polygon fill="#E59A2C" points="27.71,8 27.71,24 13.86,16 "/>
    <polygon fill="none" points="13.86,32 13.86,16 27.71,24 "/>
  	<path fill="#E59A2C" d="M26.83,25.53v12.94L15.62,32L26.83,25.53 M27.71,24l-13.86,8l13.86,8V24L27.71,24z"/>
    <polygon fill="#FFAD28" points="13.86,16 13.86,0 27.71,8 "/>
    <polygon fill="#30AA9B" points="55.43,8 55.43,24 41.57,16 "/>
  	<path fill="#30AA9B" d="M42.45,17.53L53.66,24l-11.21,6.47V17.53 M41.57,16v16l13.86-8L41.57,16L41.57,16z"/>
    <polygon fill="#33C1B3" points="41.57,16 41.57,0 55.43,8 "/>
    <polygon fill="#11557F" points="27.71,8 27.71,24 41.57,16 "/>
    <polygon fill="none" points="41.57,32 41.57,16 27.71,24 "/>
  	<path fill="#11557F" d="M28.6,25.53L39.8,32L28.6,38.47V25.53 M27.71,24v16l13.86-8L27.71,24L27.71,24z"/>
    <polygon fill="#0D5F9A" points="41.57,16 41.57,0 27.71,8 "/>
  </svg>

</template>

<script lang="ts">
  import BaseMixin from "../mixins/BaseMixin";

  export default {
    mixins: [BaseMixin]
  }
</script>